import React from 'react';
import Table from '../Table';

const mapDependentToName = (element) => {

    switch (element) {
    case 'flows': return 'Flows';
    case 'groupElements': return 'Group Element';
    case 'macroElements': return 'Macro Element';
    case 'mapElements': return 'Map Element';
    case 'navigationElements': return 'Navigation Element';
    case 'pageElements': return 'Page Element';
    case 'serviceElements': return 'Service Element';
    case 'tagElements': return 'Tag Element';
    case 'typeElements': return 'Type Element';
    case 'valueElements': return 'Value Element';
    default: return 'Unknown Element';
    }
};

/**
 * Render a list of dependencies
 *
 * @param {Object} dependents Object with a list of elements for each dependency
 *
 * Typically dependents has the following structure:
 *
 * {
 *  "existingElements": {
 *     "flows": [
 *       {
 *         "developerName": "Date Pick Test",
 *         "id": "3a8e11dc-f224-42f2-b977-2b7f4c0d899f"
 *       }
 *     ],
 *     "groupElements": [],
 *     "macroElements": [],
 *     "mapElements": [
 *       {
 *         "developerName": "Date",
 *         "id": "508a8887-bc14-42e7-a406-bbb36c3541ae"
 *       },
 *       {
 *         "developerName": "Start",
 *         "id": "676eaa8c-cdf6-4e90-b7da-3bf42fc251c0"
 *       }
 *     ],
 *     "navigationElements": [],
 *     "pageElements": [
 *       {
 *         "developerName": "Date page",
 *         "id": "2d42ecbf-3d42-4ef2-8113-9473cfb0b3bc"
 *       }
 *     ],
 *     "serviceElements": [],
 *     "tagElements": [],
 *     "typeElements": [],
 *     "valueElements": [
 *       {
 *         "developerName": "date",
 *         "id": "78dbebe0-6409-4024-9241-00f6f59c97f3"
 *       }
 *     ]
 *   }
 * }
 *
 */
const DependencyList = ({ dependents }) => {

    const columns = [
        {
            propertyName: 'developerName',
            renderHeader: () => 'Name',
            renderCell: ({ item }) => item.developerName,
        },
        {
            propertyName: 'element',
            renderHeader: () => 'Type',
            renderCell: ({ item }) => mapDependentToName(item.element),
        },
        {
            propertyName: 'id',
            renderHeader: () => 'Id',
            renderCell: ({ item }) => item.id,
        },
    ];

    // Reshape our grouped data into a list of objects for <Table> to consume.
    let items = [];
    Object.keys(dependents.existingElements).forEach((element) => {
        items = items.concat(dependents.existingElements[element]
            .map(item => ({ element, ...item })));
    });

    const keyGenerator = item => item.id;

    return (<Table items={items} columns={columns} className="table table-striped table-bordered dependency-list" keyGenerator={keyGenerator} />);
};

export default DependencyList;
